import { Button } from "@mui/material";
import { useState } from "react";
import CustomModal from "../common/custom/CustomModal";
import AllApplicationDates from "../features/admin/components/ApplicationDates/AllApplicationDates";
import ApplicationDatesForm from "../features/admin/components/ApplicationDates/ApplicationDatesForm";

function ApplicationDates() {
    const [open, setOpen] = useState(false);
  
  return (
    <>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        triggerButton={
          <Button variant="contained" onClick={() => setOpen(true)}>
            Configure Open/Closing Date
          </Button>
        }
        title="Configure closing and opening dates"
        maxWidth='md'
      >
        <ApplicationDatesForm setOpen={setOpen} />
      </CustomModal>

      <AllApplicationDates />
    </>
  );
}

export default ApplicationDates;
